var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColorSwatches(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.5 -0.5 14 14",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color-swatches--color-colors-design-painting-palette-sample-swatch"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "#ffffff",
    d: "M11.607142857142858 6.211214285714286 7.196428571428572 9.945l0 -8.415642857142858a1.8571428571428572 1.8571428571428572 0 0 1 2.3186428571428572 0.24700000000000003l1.971357142857143 1.9685714285714286c0.6825 0.6815714285714286 0.7224285714285715 1.7392142857142858 0.12071428571428572 2.4662857142857146Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fill: "#ffffff",
    d: "M0.6964285714285714 7.428571428571429v3.017857142857143a1.8571428571428572 1.8571428571428572 0 0 0 1.8571428571428572 1.8571428571428572h2.7857142857142856a1.8571428571428572 1.8571428571428572 0 0 0 1.8571428571428572 -1.8571428571428572V7.428571428571429h-6.5Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fill: "#fdba74",
    fillRule: "evenodd",
    d: "m4.410714285714286 12.303571428571429 6.035714285714286 0a1.8571428571428572 1.8571428571428572 0 0 0 1.8571428571428572 -1.8571428571428572v-2.7857142857142856c0 -0.5868571428571429 -0.2720714285714286 -1.1096428571428572 -0.6964285714285714 -1.4495L7.196428571428572 9.945v0.5014285714285714a1.8571428571428572 1.8571428571428572 0 0 1 -1.8571428571428572 1.8571428571428572h-0.9285714285714286Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_3",
    fill: "#fdba74",
    fillRule: "evenodd",
    d: "M0.6964285714285714 2.553571428571429V7.428571428571429h6.5V2.553571428571429a1.8571428571428572 1.8571428571428572 0 0 0 -1.8571428571428572 -1.8571428571428572h-2.7857142857142856a1.8571428571428572 1.8571428571428572 0 0 0 -1.8571428571428572 1.8571428571428572Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1161",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.6964285714285714 10.446428571428571v-7.892857142857143a1.8571428571428572 1.8571428571428572 0 0 1 1.8571428571428572 -1.8571428571428572h2.7857142857142856a1.8571428571428572 1.8571428571428572 0 0 1 1.8571428571428572 1.8571428571428572v7.892857142857143a1.8571428571428572 1.8571428571428572 0 0 1 -1.8571428571428572 1.8571428571428572h-2.7857142857142856a1.8571428571428572 1.8571428571428572 0 0 1 -1.8571428571428572 -1.8571428571428572Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_2",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.6964285714285714 7.428571428571429v3.017857142857143a1.8571428571428572 1.8571428571428572 0 0 0 1.8571428571428572 1.8571428571428572h2.7857142857142856a1.8571428571428572 1.8571428571428572 0 0 0 1.8571428571428572 -1.8571428571428572V7.428571428571429h-6.5Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 115",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.9285714285714286 7.428571428571429h6.035714285714286",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 116",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.9285714285714286 4.178571428571429h6.035714285714286",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1159",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.9464285714285716 9.78157142857143v0.169",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 114",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m4.410714285714286 12.303571428571429 6.035714285714286 0a1.8571428571428572 1.8571428571428572 0 0 0 1.8571428571428572 -1.8571428571428572v-2.7857142857142856c0 -0.5868571428571429 -0.2720714285714286 -1.1096428571428572 -0.6964285714285714 -1.4504285714285716",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_4",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m11.488285714285714 6.37 -4.3067142857142855 4.315071428571429c0.009285714285714286 -0.07800000000000001 0.014857142857142859 -0.15785714285714286 0.014857142857142859 -0.23864285714285716V1.5293571428571429a1.8571428571428572 1.8571428571428572 0 0 1 2.3186428571428572 0.24700000000000003l1.971357142857143 1.9685714285714286a1.8571428571428572 1.8571428571428572 0 0 1 0.0018571428571428573 2.626Z",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorSwatches);
export default __webpack_public_path__ + "static/media/color-swatches.0e75fcdca2d14bfcdf1b31cc9449b82c.svg";
export { ForwardRef as ReactComponent };